import { ApprovedMedia, ApprovedSeries, CoherentScreen, CuratedMediaList, CuratedSeriesList, ProcessedMediaStates, WatchingProfileMetric } from "models";
import rq from 'components/RedQuick'
import React from "react";
import { useTheme } from "@emotion/react";
import { Views } from "enumerations";
import { ResolvePath, GetCachedUrls, ResolveStorageUrl } from "features/firebase-app";
import { useDispatch, useSelector } from "react-redux";
import { useParams, useNavigate } from "react-router-dom";
import profile from "react-syntax-highlighter/dist/esm/languages/hljs/profile";
import TitleService from "title-service";
import { useLocalId, useBrowserInfo, mobileAndTabletCheck, useStutter } from "./utility";
import { get_selected_device } from "features/device/device-slice";
import MainCard from "ui-component/cards/MainCard";
import RedQuickLoLoList from "./RedQuickLoLoList";

export interface CoherentScreenViewComponentProperties {
    coherentScreen: CoherentScreen,
    coherentScreen_list: CoherentScreen[],
    approvedSeries_list: ApprovedSeries[],
    approvedMedia_list: ApprovedMedia[],
    curatedSeriesList_list: CuratedSeriesList[];
    watchingProfileMetric_list: WatchingProfileMetric[];
    curatedMediaList_list: CuratedMediaList[]
}
export default function CoherentScreenViewComponent({
    coherentScreen,
    coherentScreen_list,
    approvedSeries_list,
    approvedMedia_list,
    curatedSeriesList_list,
    watchingProfileMetric_list,
    curatedMediaList_list
}: CoherentScreenViewComponentProperties) {
    const [watchingMediaDicArgs, setWatchingMediaDicArgs] = React.useState(null)
    const theme = useTheme()
    const params = useParams()
    let dispatch = useDispatch()
    const navigate = useNavigate()
    const browserInfo = useBrowserInfo()
    let device = useSelector(get_selected_device)
    const [previewDicMetric, setPreviewDicMetric] = React.useState(null)
    const componentRef: React.Ref<HTMLDivElement> = React.useRef(null)
    const [urlUpdated, setUrlUpdated] = React.useState(null)
    const componentRef_size = rq.useContainerSize(componentRef)

    if (!coherentScreen || !coherentScreen_list || coherentScreen_list?.length === 0) {
        return <></>
    }
    let mylist: any = [];
    let mysections: string[] = [];
    let tempApprovedSeries: any = null;
    if (coherentScreen?.highlightSeriesId) {
        tempApprovedSeries = approvedSeries_list.find(v => v.seriesId === coherentScreen?.highlightSeriesId);
        if (!tempApprovedSeries) {
            tempApprovedSeries = approvedMedia_list.find(v => v.mediaId === coherentScreen?.highlightSeriesId);
        }
    }
    coherentScreen?.orderedReferenceList?.forEach((itemReferenceId) => {
        let csl = curatedSeriesList_list.find(v => v.id === itemReferenceId);
        if (csl?.series?.map) {
            mylist.push(csl.series.map((serie) => {

                let sized_video_url = getSrc(serie.titleMediaLocation, serie.titleMediaUrl, 200);

                let sized_url = getSrc(serie.titleMediaImageLocation, serie.titleMediaImageUrl, 200);
                if (!sized_url) {
                    return null;
                }
                let foundWatchingPreviewProfileMetric = watchingProfileMetric_list.find(v => v.seriesId === serie.id && v.currentPosition)
                return ({
                    color: 'transparent', component: <rq.DisneyComponent
                        panelStyle={{
                            ['--hover-color']: theme?.palette?.dark[900] || '#ffffff'
                        }}
                        onPlaying={(args) => {
                            setWatchingMediaDicArgs({
                                ...(watchingMediaDicArgs || {}),
                                [serie.id]: {
                                    ...browserInfo,
                                    ...args,
                                    device: device?.id,
                                    profile: profile?.id,
                                    series: serie.id,
                                    media: null
                                }
                            });
                            let viewedSections = [];
                            if (previewDicMetric && previewDicMetric[serie.id]) {
                                viewedSections = previewDicMetric[serie.id].viewedSections;
                            }
                            else {
                                viewedSections = new Array(100).fill(0);
                            }
                            if (args.duration) {
                                let index = Math.round(100 * args.currentTime / args.duration);
                                viewedSections[index] = 1;
                                if (args.duration < 100) {
                                    if (index > 0) {
                                        viewedSections[index - 1] = 1;
                                    }
                                    if (index < 99) {
                                        viewedSections[index + 1] = 1;
                                    }
                                }
                                setPreviewDicMetric({
                                    ...(previewDicMetric || {}),
                                    [serie.id]: {
                                        seriesId: serie.id,
                                        mediaId: null,
                                        profileId: profile?.id,
                                        viewedSections: [...viewedSections],
                                        currentPosition: 0,
                                    }
                                });
                            }
                        }}
                        onViewing={() => {

                        }}
                        videoUrl={sized_video_url || serie.titleMediaUrl}
                        title={serie.name}
                        imageSrc={sized_url || serie.titleMediaImageUrl}
                        altText={serie.name}
                        currentPosition={foundWatchingPreviewProfileMetric?.currentPosition || 0}
                        onPlay={() => {
                            console.log('play movie')
                            let apSeries = approvedSeries_list.find(v => v.seriesId === serie.id)
                            // if (apSeries?.seasons[0] && apSeries.seasons[0].approvedMedia?.length) {
                            //     let approvedMediaId = apSeries.seasons[0].approvedMedia[0];
                            //     let approvedMedia = approvedMedia_list.find(x => x.id === approvedMediaId);
                            //     navigate(`/${Views.Watch}/${apSeries?.id}/${approvedMedia.mediaId}/${approvedMedia.id}`)
                            // }
                        }} onOpen={() => {
                            console.log('open');
                            navigate(ResolvePath(`/${getLocationPath()}/${coherentScreen?.id}/${serie?.id}`));
                        }} />
                })
            }).filter(x => x));
            mysections.push(csl.name);
        }
        else {
            let cml = curatedMediaList_list.find(v => v.id === itemReferenceId);
            if (cml?.media?.map) {
                mylist.push(cml.media.map((mediaItem) => {
                    let sized_url = '';
                    let sized_video_url = '';
                    let approvedMediaItem = approvedMedia_list.find(x => x?.mediaId === mediaItem.id)
                    if (approvedMediaItem?.hidden) {
                        return null;
                    }

                    sized_video_url = getSrc(mediaItem.mediaPreviewLocation, mediaItem.mediaPreviewUrl, 200);
                    // If there is a thumbnail default don't fetch any more.
                    sized_url = getSrc(mediaItem.thumbnailDefaultUrl ? null : mediaItem.thumbnailLocation, mediaItem.thumbnailDefaultUrl || mediaItem.thumbnail, 200);
                    if (!sized_url) {
                        return null;
                    }
                    let foundWatchingPreviewProfileMetric = watchingProfileMetric_list.find(v => v.mediaId === mediaItem.id)
                    return {
                        video: sized_video_url || mediaItem.mediaPreviewUrl || mediaItem.mediaRel,
                        title: mediaItem.name,
                        imageSrc: sized_url || mediaItem.thumbnailDefaultUrl || mediaItem?.thumbnail,
                        altText: mediaItem.name,
                        id: mediaItem.id,
                        currentPosition: foundWatchingPreviewProfileMetric?.currentPosition || 0
                    }
                }).filter(x => x).map((t) => {
                    return ({
                        color: 'transparent', component: <rq.DisneyComponent
                            panelStyle={{
                                ['--hover-color']: theme?.palette?.dark[900] || '#ffffff'
                            }}
                            onPlaying={(args) => {
                                setWatchingMediaDicArgs({
                                    ...(watchingMediaDicArgs || {}),
                                    [t.id]: {
                                        ...browserInfo,
                                        ...args,
                                        device: device?.id,
                                        profile: profile?.id,
                                        media: t.id,
                                        series: null,
                                        currentPosition: args.currentTime / args.duration,
                                    }
                                });
                                if (args.duration) {

                                    let viewedSections = [];
                                    if (previewDicMetric && previewDicMetric[t.id]) {
                                        viewedSections = previewDicMetric[t.id].viewedSections;
                                    }
                                    else {
                                        viewedSections = new Array(100).fill(0);
                                    }
                                    let index = Math.round(100 * args.currentTime / args.duration);
                                    viewedSections[index] = 1;
                                    if (args.duration < 100) {
                                        if (index > 0) {
                                            viewedSections[index - 1] = 1;
                                        }
                                        if (index < 99) {
                                            viewedSections[index + 1] = 1;
                                        }
                                    }
                                    setPreviewDicMetric({
                                        ...(previewDicMetric || {}),
                                        [t.id]: {
                                            mediaId: t.id,
                                            seriesId: null,
                                            profileId: profile?.id,
                                            viewedSections: [...viewedSections],
                                            currentPosition: args.currentTime / args.duration,
                                        }
                                    })
                                }

                            }}
                            onViewing={() => {

                            }}
                            currentPosition={t?.currentPosition || 0}
                            videoUrl={t.video}
                            title={t.title}
                            imageSrc={t.imageSrc}
                            altText={t.altText}
                            onPlay={() => {
                                console.log('play movie')
                                let approvedMedia = approvedMedia_list.find(
                                    (v) => v.mediaId === t?.id,
                                )

                                // navigate(
                                //     `/${Views.Watch}/inde/${t?.id}/${approvedMedia?.id}`,
                                // )
                            }} onOpen={() => {
                                console.log('open');
                                navigate(ResolvePath(`/${getLocationPath()}/${coherentScreen?.id}/${t?.id}`));
                            }} />
                    })
                }))
                mysections.push(cml.name);
            }
        }
    });
    const lists = [...mylist]; //, ...(Array.from({ length: 6 }).map(() => getList()))
    const sections = [...mysections]; // , ...Array.from({ length: 6 }).map((_: any, i: number) => `Section ${i}`)
    let approvedMedia = approvedMedia_list.find(
        (v) => v.mediaId === tempApprovedSeries?.media?.id,
    )
    let season: any = null
    if (
        tempApprovedSeries?.seasons &&
        tempApprovedSeries?.seasons[0]
    ) {
        season = tempApprovedSeries?.seasons[0]
    }
    if (season) {
        approvedMedia = approvedMedia || season?.approvedMedia
            ?.map((m) => {
                return approvedMedia_list.find((v) => v.id === m)
            })[0];
    }
    return (
        <MainCard title={''}>
            <div style={{ overflow: 'hidden', paddingBottom: '15rem' }}>
                <div style={{ position: 'relative', zIndex: 10 }} ref={componentRef}>
                    <div style={{ position: 'relative' }}>
                        <RedQuickLoLoList
                            lists={lists}
                            sections={sections}
                            itemsPerSlide={Math.min(Math.max(Math.floor(componentRef_size.width / 1500 * 5), 1), 6)}
                            itemContainerCls="lolo__panel__container" />
                    </div>
                </div>
            </div>
        </MainCard>);
    function getSrc(location: string, url: string, size: number) {
        let states: ProcessedMediaStates[] = []
        approvedSeries_list.find((approved_series) => {
            if (approved_series?.processedSeries?.states) {
                states.push(
                    ...approved_series?.processedSeries?.states?.filter((st) => {
                        let found = st.sourceLocation === location
                        return found
                    }),
                )
            }
        })
        if (!states.length) {
            approvedMedia_list.find((approved_media) => {
                if (approved_media?.processedMedia?.states) {
                    states.push(
                        ...approved_media?.processedMedia?.states?.filter((st) => {
                            let found = st.sourceLocation === location
                            return found
                        }),
                    )
                }
            })
        }
        if (states.length) {
            states = states.sort((a, b) => {
                return Math.abs(a.width - size) - Math.abs(b.width - size)
            })
            let temp = states.filter((a) => a.width - size > 0)
            let state = temp[0] || states[0]
            let cached_url = GetCachedUrls(state.location)
            if (!cached_url) {
                ResolveStorageUrl(state.location).then((res) => {
                    if (res) {
                        setUrlUpdated((urlUpdated || 0) + 1)
                    }
                })
            } else {
                return cached_url
            }
            if (mobileAndTabletCheck()) {
                return null
            }
        }
        return url
    }

}


export function getLocationPath(): string {
    if (location.href.indexOf(Views.PreviewCoherentScreen) !== -1) {
        return Views.PreviewCoherentScreen
    }
    return Views.Browse
}